import { useEffect, useState } from "react";

import styles from "../../../../styles/mensageria.module.scss";
import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Message } from "../../../components/Message";
import { If } from "../../../components/control-statements";

export const TemplateAdd = ({
  template,
  nextStep,
  setup,
  onChangeSetup,
  onChangeTemplate,
}) => {
  const [elementsTemplate, setElementsTemplate] = useState(setup);

  useEffect(() => {
    onChangeSetup(elementsTemplate);

    const buttons = elementsTemplate?.buttons
      ? template.structure?.buttons
      : [];
    const footer = elementsTemplate?.footer ? template.structure?.footer : null;
    const header = elementsTemplate?.header ? template.structure?.header : null;

    const updatedTemplate = {
      ...template,
      structure: {
        ...template.structure,
        header,
        buttons,
        footer,
      },
    };

    onChangeTemplate(updatedTemplate);
  }, [elementsTemplate]);

  return (
    <div className={styles.scrollContainer}>
      <Label>Insira o nome para o template</Label>
      <Input
        placeholder="Nome do template"
        className="w-100"
        onChange={(e) =>
          onChangeTemplate({
            ...template,
            name: e.target.value.replace(/[^a-z_]/gi, "").toLowerCase(),
          })
        }
        value={template?.name}
      />
      <Message className="mt-10">Utilize apenas a-z e sublinhado (_).</Message>

      <Hairline solid className="mt-20 mb-20" />
      <Label>Elementos do template</Label>
      <Checkbox checked readOnly>
        Corpo
      </Checkbox>
      <Hairline solid className="mb-15 mt-20" />
      <Checkbox
        checked={elementsTemplate?.header}
        onChange={() =>
          setElementsTemplate({
            ...elementsTemplate,
            header: !elementsTemplate?.header,
          })
        }
        className="mb-10"
      >
        Cabeçalho
      </Checkbox>
      <Checkbox
        checked={elementsTemplate?.footer}
        onChange={() =>
          setElementsTemplate({
            ...elementsTemplate,
            footer: !elementsTemplate?.footer,
          })
        }
        className="mb-10"
      >
        Rodapé
      </Checkbox>
      <Checkbox
        checked={elementsTemplate?.buttons}
        onChange={() =>
          setElementsTemplate({
            ...elementsTemplate,
            buttons: !elementsTemplate?.buttons,
          })
        }
        className="mb-30"
      >
        Botões
      </Checkbox>

      <Label className="mt-30">Prévia do template</Label>

      <div className={styles.previewTemplate}>
        <If cond={elementsTemplate?.header}>
          <div className={styles.templateHeader}>
            <div className={styles.box} />
          </div>
        </If>
        <div className={styles.templateBody}>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500.
        </div>
        <If cond={elementsTemplate?.footer}>
          <div className={styles.templateFooter}>
            If you are going to use a passage of Lorem Ipsum, you need to be
            sure there isn't anything embarrassing hidden in the middle of text.
          </div>
        </If>
        <If cond={elementsTemplate?.buttons}>
          <div className={styles.buttons}>
            <div className={styles.button}>Acesse o clube</div>
            <div className={styles.button}>Botão 1</div>
            <div className={styles.button}>Botão 2</div>
          </div>
        </If>
      </div>

      <div className={styles.footer}>
        <Button
          text="Avançar"
          design="primary"
          className="w-100"
          disabled={!template?.name}
          onClick={nextStep}
        />
      </div>
    </div>
  );
};
